var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"font-weight-bold",class:[_vm.$vuetify.breakpoint.mdAndUp ? 'display-3' : 'headline']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }